import axios from '../../utils/http/http';
import { triggerNotification } from '../../utils/NotificationContext';

/**get cycle trigger grid data w/o pagination */
export const fetchCycleTriggerData = async (buName) => {
  try {
    const response = await axios.getRequest(
      `/tpo/getAllCycle?businessUnitName=${encodeURIComponent(buName)}&version=v2`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get cycle trigger data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

/**create cycle */
export const createCycle = async (params, userName) => {
  try {
    const response = await axios.postRequest(`/tpo/createCycle?userName=${userName}`, params);
    const successMessage = response?.message || 'Cycle Created Successfully!';
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data || 'Failed to Create Cycle!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

/**update cycle */
export const updateCycle = async (params, userName) => {
  try {
    const response = await axios.postRequest(`/tpo/updateFlagValue?userName=${userName}`, params);
    const successMessage = response?.message || 'Cycle/s Updated Successfully!';
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to Update Cycle/s!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

/**start cycle */
export const startCycle = async (selectedCycleId, userName) => {
  try {
    const response = await axios.getRequest(
      `/tpo/startCycle?id=${selectedCycleId}&userName=${userName}`
    );

    const successMessage = response?.message || 'Cycle Started Successfully!';
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to start cycle!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

/**delete cycle */
export const deleteCycle = async (selectedCycleId, userName) => {
  try {
    const response = await axios.deleteRequest(
      `/tpo/deleteCycle/${selectedCycleId}?userName=${userName}`
    );
    const successMessage = response?.message || 'Cycle deleted Successfully!';
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to delete data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

/**history data */
export const fetchHistoryDetails = async (selectedCycleId) => {
  try {
    const response = await axios.getRequest(`/tpo/getCycleHistory/${selectedCycleId}`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to delete data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

/**select active cycle */
export const selectActiveCycle = async (id, buName) => {
  try {
    const response = await axios.postRequest(
      `/tpo/selectActiveCycle?cycleId=${id}&businessUnitName=${encodeURIComponent(buName)}`
    );
    const successMessage = response?.message || 'Active Cycle Updated Successfully!';
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to Update Active Cycle!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

/**edit cycle period */
// cycleID,startPeriod,endPeriod
export const editCyclePeriod = async (params, username) => {
  try {
    const response = await axios.postRequest(`/tpo/updateCyclePeriod?userName=${username}`, params);
    const successMessage = response?.message || 'Cycle period updated Successfully!';
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data || 'Failed to Create Cycle!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchGlobalCyclesQueue = async (selectedBu, pageNo, pageSize) => {
  try {
    // Ensure axios is used correctly here
    const response = await axios.getRequest(
      `/tpo/getGlobalCyclesQueue?businessUnitName=${encodeURIComponent(selectedBu)}&pageNo=${pageNo}&pageSize=${pageSize}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch global cycle queue data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const updateGoalsForCycle = async (cycleId, payload) => {
  try {
    const response = await axios.postRequest(`/tpo/updateCycleGoals?cycleId=${cycleId}`, payload);
    const successMessage = response?.message || 'Updated goals for cycle Successfully!';
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to Create Cycle!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchPeriodDates = async (bu, timeFrame) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/getTimeFrame/${encodeURIComponent(bu)}?timeFrame=${timeFrame}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch periods!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
